
<div style="display: flex; " v-if="site">
    <div>
        <c-site-title-row-comment
            :site = "site"
            style="padding-top: 4px; padding-right: 4px;"
        />
    </div>

    <div v-if="site.status">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <div
                    class  = "site-status"
                    :class = "statusColorUnit"
                    v-bind = "attrs"
                    v-on   = "on"
                ></div>
            </template>
            <span>{{ site.status.name }}</span>
        </v-tooltip>
    </div>


    <div>
        <v-tooltip
            bottom
            :content-class="statusColor"
        >
            <template v-slot:activator="{ on, attrs }">
                <div
                    class  = " lm-status"
                    :class = "statusColor"
                    v-bind = "attrs"
                    v-on="on"
                >
                    <div
                        :class="isInLim ? (site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate ? 'black--text' : 'white--text') : 'primary--text'"
                    >
                        {{ contractType ? contractType : '---' }}
                    </div>
                </div>
            </template>
            <div :class="isInLim ? (site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate ? 'black--text' : 'white--text') : 'primary--text'">
                <div style="font-weight: 600" v-if="site && site.liftmanagement">
                    {{ site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.type ? site.liftmanagement.contract.type.name : 'kein Vertrag' }}
                </div>
                <div>Laufzeit von {{ start }} bis {{ end }}</div>
                <div class="white " v-if="site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate">Vertrag wird beendet</div>
            </div>
        </v-tooltip>
    </div>

    <div v-if="tier">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    x-small
                    :color      = "tierBadgeColor"
                    :text-color = "tierBadgeTextColor"
                    class       = "mr-1"
                    v-bind      = "attrs"
                    v-on        = "on"
                >
                    {{ tier }}
                </v-chip>
            </template>
            <span>Vertragsstufe: {{ tier }}</span>
        </v-tooltip>
    </div>

    <div v-if="!hideType">
        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    color="white"
                    size="25"
                    class="mr-1 site-icon"
                    v-bind="attrs"
                    v-on="on"
                    style="vertical-align: unset;"
                >
                    {{ site.type.symbol }}
                </v-icon>
            </template>
            <span>{{ site.type.name }}</span>
        </v-tooltip>
    </div>


    <v-tooltip bottom content-class="custom-tooltip white">
        <template v-slot:activator="{ on, attrs }">
            <div
                v-bind = "attrs"
                v-on   = "on"
                class="v-flex"
            >
                <div class="site-header" >
                    {{ $t('top.site.title', [ site.fabricNo, site.customer.name ]) }}
                </div>
                <div class="site-location">
                    {{ location }}
                </div>
            </div>
        </template>
        <div class="lm-border primary-border-thick pa-2 black--text" style="width: 500px">
            <v-row dense>
                <v-col class="no-frame col-3">
                    Buchungskreis
                </v-col>
                <v-col class="no-frame">
                    {{ site.ve }}
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="no-frame col-3">
                    Wirtschaftseinheit
                </v-col>
                <v-col class="no-frame">
                    {{ site.ve2 }}
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="no-frame col-3">
                    VE3
                </v-col>
                <v-col class="no-frame">
                    {{ site.ve3 }}
                </v-col>
            </v-row>
        </div>
    </v-tooltip>
</div>
